export function getBoundingClientRect(element: HTMLElement | SVGElement): DOMRect {
	//IE/Edge don't know the x and y property: https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
	const rect = element.getBoundingClientRect();
	rect.x ??= rect.left;
	rect.y ??= rect.top;

	return rect;
}
